import { yupResolver } from '@hookform/resolvers/yup';
import SpreedlyForm from 'components/payment/spreedly/spreedly-card/forms/spreedly-form.component';
import { spreedlyFormSubmit } from 'components/payment/spreedly/spreedly-card/forms/spreedly-form.hooks';
import { getSchema } from 'components/payment/spreedly/spreedly-card/spreedly-card.utils';
import { useMobileAppListeners } from 'hooks/mobileAppListeners/useMobileAppListeners';
import { FormProvider, useForm } from 'react-hook-form';

const SpredlyPaymentHostedForm = ({
  initOrderResponse,
  loading,
  refetchInitOrder,
}) => {
  const initOrderAttributes = initOrderResponse?.attributes;
  const formName = initOrderAttributes?.hostedPaymentPageName;

  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: yupResolver(getSchema(formName)),
  });

  const { handleSubmit } = methods;

  const fireListeners = useMobileAppListeners();

  const onSuccess = (_token, data) => {
    fireListeners(data);
  };

  const onError = () => {
    refetchInitOrder();
  };

  const submit = () => {
    spreedlyFormSubmit(handleSubmit, data => {
      window.Spreedly.tokenizeCreditCard(data);
    })();
  };

  return (
    <FormProvider {...methods}>
      <SpreedlyForm
        formName={formName}
        initOrderAttributes={initOrderAttributes}
        onSuccess={onSuccess}
        onError={onError}
        showSaveCardCheckbox={false}
        submit={submit}
        disabled={loading}
        button
      />
    </FormProvider>
  );
};

export default SpredlyPaymentHostedForm;
